import React,{useEffect} from 'react'
import { PDFObject } from 'react-pdfobject'
import { canOpenURL } from '../../utils/url'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import styled from 'styled-components'
import ChromeReaderModeIcon from '@material-ui/icons/ChromeReaderMode';
import Button from '@material-ui/core/Button'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { useMutation} from '@apollo/react-hooks'
import { courseMutations } from '../../graphql/mutations/'

const ReadingPlaceHolder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #421fe3;
`

const ContentReading = ({ content,courseId, id ,presentation }) => {
 

  useEffect(() => {
    
      if (!presentation) {
        id && courseId && adicionaProgresso({
              variables: {
                  conteudoId:id,
                  cursoId:courseId
              }
          })
      }

  }, [])  

  const [adicionaProgresso] = useMutation(courseMutations.ADD_PROGRESS)
  
  const defaultBreakpoint = useMediaQuery('(min-width:1050px)')

  if(!canOpenURL(content.url)) return null

  return (
    defaultBreakpoint ? <PDFObject width="100%" height="100%" url={content.url} />
    :
    <ReadingPlaceHolder>
      <ChromeReaderModeIcon style={{ color: '#FFF', fontSize: '3.5rem' }}/>
      <Button
      component={'a'}
      download
      href={(content || {}).url}
      variant="outlined"
      color="white"
      style={{ marginTop: '16px', color: '#FFF', borderColor: 'white', alignSelf: 'unset' }}
      startIcon={<CloudDownloadIcon style={{ fontSize: '16px' }} />}
      > baixar arquivo pdf </Button>
    </ReadingPlaceHolder>
  )
}

export default ContentReading
